const formatter = Intl.DateTimeFormat("en-US", {
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  month: "short",
  year: "numeric",
});

export function dateFormatterWithHour(
  date: Date | null | string | undefined,
): string {
  if (!date) return "";

  return formatter.format(new Date(date));
}
